import { Component, OnInit } from '@angular/core';
import { GlobalDataService } from '../../_shared';
import { ReportService } from '../../_services';
import { LoginUser } from '../../_models';

@Component({
  selector: 'app-log-report',
  templateUrl: './log-report.component.html',
  styleUrls: ['./log-report.component.css']
})
export class LogReportComponent implements OnInit {
  user: LoginUser = new LoginUser;
  getYrs : string[]=[];
  Year = '0';  
  vowdLog: any[] = [];
  vowdTotal: number=0;
  p: any;
  constructor(private gd : GlobalDataService,
    private reportService  : ReportService) { }

  ngOnInit() {
    this.user = this.gd.getUserData();
    this.getAcurlYr();
  }

  getAcurlYr()
  {
    
    for (var i = 0; i <= 20; i++) {
      this.getYrs.push(((new Date().getFullYear()) - i).toString());
    }
  }

  getVowdLog()
  {

    this.reportService.vowdLogReport(this.Year).subscribe(data=>{
      this.vowdLog = data;
      for (let i=0;i<this.vowdLog.length;i++)
      {
     
      }
    });
  }
  
}
